import React, { useState } from "react";
import { Col, Divider, Modal, Row } from "antd";
import { useBailiffUpload } from "hook/bailiff/document/action/useBailiffUpload";
import { useSelector } from "react-redux";
import { bailiffDocumentOpenUploadSelector } from "store/bailiff/bailiff/document/bailiff_document.selector";
import UploadStepper from "./component/upload_stepper";
import UploadAudio from "./component/upload_audio";
import UploadFinish from "./component/upload_finish";
import UploadPreview from "./component/upload_preview";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DialogPaymentUploadVer2 = () => {
  // -------------------------- VAR -----------------------------
  const { handleCancel } = useBailiffUpload();
  // -------------------------- STATE ---------------------------
  const [audio, setAudio] = useState(null);
  // -------------------------- REDUX ---------------------------
  const open = useSelector(bailiffDocumentOpenUploadSelector);
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Modal
      onCancel={handleCancel}
      open={open}
      title="Dịch Thuật Văn Bản"
      footer={null}
      width={800}
    >
      <Divider dashed className="my-[10px]" />
      <Row gutter={[30, 30]}>
        <Col xl={24} lg={24} md={24} xs={24}>
          <UploadStepper />
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          <UploadAudio setAudio={setAudio} />
          <UploadPreview audio={audio} />
          <UploadFinish />
        </Col>
      </Row>
    </Modal>
  );
};
export default DialogPaymentUploadVer2;
